import { createSignal, onMount } from "solid-js";
import { View, Text } from "@lightningtv/solid";
import styles from "../styles";

export default function PinKeyboardFast(props: {
    onSubmit: (pin: string) => void;
    keyboardRef?: any;
    isEnterEnabled?: boolean;
    onEnterAttempt?: () => void;
}) {
    const layout = [
        ["1", "2", "3"],
        ["4", "5", "6"],
        ["7", "8", "9"],
        ["Del", "0", "Enter"]
    ];

    const refs: Array<Array<any>> = layout.map(() => []);
    const [inputValue, setInputValue] = createSignal("");

    onMount(() => {
        refs[0][0]?.setFocus?.();

        if (props.keyboardRef) {
            props.keyboardRef.resetInput = () => setInputValue("");
        }
    });

    const handleKeyPress = (key: string) => {
        // Block ALL input if Enter is not enabled (during timeout)
        if (props.isEnterEnabled === false) {
            console.log('Input disabled - please wait for timeout to complete');
            props.onEnterAttempt?.(); // Call callback for any key press attempt
            return; // Don't process ANY key press
        }

        if (key === "Del") {
            setInputValue((prev) => prev.slice(0, -1));
        } else if (key === "Enter") {
            if (inputValue().length === 4) {
                props.onSubmit(inputValue());
            } else {
                console.log('PIN must be 4 digits');
            }
        } else {
            setInputValue((prev) => {
                const newValue = prev + key;
                if (newValue.length === 4) {
                    props.onSubmit(newValue); // auto-submit when 4 digits are entered
                }
                return newValue.length <= 4 ? newValue : prev;
            });
        }
    };


    return (
        <View>
            {/* PIN display as 4 boxes */}
            <View x={150} y={140}>
                {[0, 1, 2, 3].map((i) => (
                    <View borderRadius={8} width={70} height={70} color={"#333"} x={i * 100}>
                        <Text x={22} y={20} fontSize={48}>
                            {inputValue().length > i ? "*" : ""}
                        </Text>
                    </View>
                ))}
            </View>

            {/* Keyboard */}
            <View x={140} y={250}>
                {layout.map((row, rowIndex) => (
                    <View y={rowIndex * 95}>
                        {row.map((key, colIndex) => (
                            <View
                                ref={(el) => (refs[rowIndex][colIndex] = el)}
                                x={colIndex * 135}
                                style={styles.buttonKeyPin}
                                onEnter={() => handleKeyPress(key)}
                                onRight={() => refs[rowIndex][colIndex + 1]?.setFocus?.()}
                                onLeft={() => refs[rowIndex][colIndex - 1]?.setFocus?.()}
                                onDown={() => refs[rowIndex + 1]?.[colIndex]?.setFocus?.()}
                                onUp={() => refs[rowIndex - 1]?.[colIndex]?.setFocus?.()}
                            >
                                {key === "Del" ? (
                                    <View
                                        src="https://i.ibb.co/wh6n5N3X/backspace.png"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            x: 37,
                                            y: 20,
                                            opacity: props.isEnterEnabled === false ? 0.3 : 1
                                        }}
                                    />
                                ) : key === "Enter" ? (
                                    <View
                                        src="https://i.ibb.co/FbFMtxMw/check.png"
                                        style={{
                                            width: 40,
                                            height: 40,
                                            x: 37,
                                            y: 20,
                                            opacity: props.isEnterEnabled === false ? 0.3 : 1
                                        }}
                                    />
                                ) : (
                                    <Text
                                        fontSize={32}
                                        x={50}
                                        y={25}
                                        color={"#fff"}
                                    >
                                        {key}
                                    </Text>
                                )}
                            </View>
                        ))}
                    </View>
                ))}
            </View>
        </View>
    );
}